import React, { Component } from "react";
import { Chip, Avatar, Tooltip } from "@material-ui/core";
import { checkRefereeWishLocation } from "../../util/CheckRefereeWishLocation";
import { checkRefereeWishDay } from "../../util/CheckRefereeWishDay";
import { checkRefereeWishMaxMatches } from "../../util/CheckRefereeWishMaxMatches";
import ErrorIcon from "@material-ui/icons/Error";
import { languages } from "../../constants/languages";
import { mdiWhistle } from "@mdi/js";
import Icon from "@mdi/react";

class RefereeChip extends Component {
  highlightReferee = (refereeId) => {
    let refereeElements = document.getElementsByClassName(
      "teamElementId" + refereeId
    );
    // let teamElements = document.getElementsByClassName("teamElement");
    for (var i = 0; i < refereeElements.length; i++) {
      let element = refereeElements[i];
      // element.style.letterSpacing = "-0.0642em";
      // element.style.fontWeight = 600;
      element.style.textShadow = "1px 0px 0px black";
    }
    // let name = this.props.referee.name || "";
    // if (this.props.tournament.teamsAsRefs) {
    //   for (var x = 0; x < teamElements.length; x++) {
    //     let element = teamElements[x];
    //     if (element.textContent === name) {
    //       element.style.fontWeight = "bold";
    //     }
    //   }
    // }
  };

  unHighlightReferee = (refereeId) => {
    let refereeElements = document.getElementsByClassName(
      "teamElementId" + refereeId
    );
    // let teamElements = document.getElementsByClassName("teamElement");
    for (var i = 0; i < refereeElements.length; i++) {
      let element = refereeElements[i];
      // element.style.fontWeight = "";
      // element.style.letterSpacing = "0.01071em";
      element.style.textShadow = "0px 0px 0px black";
    }

    // let name = this.props.referee.name || "";
    // if (this.props.tournament.teamsAsRefs) {
    //   for (var x = 0; x < teamElements.length; x++) {
    //     let element = teamElements[x];
    //     if (element.textContent === name) {
    //       element.style.fontWeight = "";
    //     }
    //   }
    // }
  };

  render() {
    let wishTitles = [];
    let wish = true;

    let locationWish = checkRefereeWishLocation(
      this.props.referee,
      this.props.selectedSportPark
    );
    let dayWish = checkRefereeWishDay(
      this.props.referee,
      this.props.selectedDay
    );
    let numMatches = this.props.matches.filter(
      (m) =>
        m.referee === this.props.refereeId ||
        m.referee2 === this.props.refereeId ||
        m.referee3 === this.props.refereeId ||
        m.referee4 === this.props.refereeId ||
        m.referee5 === this.props.refereeId
    ).length;
    if (numMatches > 0 && !this.props.inSidebar) {
      numMatches--;
    }
    let maxMatchesWish = checkRefereeWishMaxMatches(
      this.props.referee,
      numMatches
    );
    let roles = this.props.referee.roles || "all";

    let roleWish =
      roles === "all" || roles.indexOf(this.props.refereeRole) !== -1;

    let team1 = this.props.team1 || {};
    let team2 = this.props.team2 || {};
    let teamWish =
      (this.props.referee.excludeTeams || []).indexOf(team1.id) === -1 &&
      (this.props.referee.excludeTeams || []).indexOf(team2.id) === -1;

    let teamWish2 = true;
    (this.props.referee.excludeTeams || []).forEach((tId) => {
      if (!(this.props.teamsByKey[tId] || {}).poule0) {
        teamWish2 = false;
        wish = false;
        wishTitles.push(
          languages.formatString(
            languages.referees.teamNotDivided,
            (this.props.teamsByKey[tId] || {}).name || ""
          )
        );
      }
    });

    let divisions = this.props.referee.divisionsReferee || "all";

    let divisionWish =
      divisions === "all" || divisions.indexOf(this.props.division) !== -1;

    let fieldWish = true;
    if (
      this.props.match &&
      this.props.match.field !== null &&
      this.props.match.field !== undefined
    ) {
      fieldWish = checkRefereeWishLocation(
        this.props.referee,
        this.props.selectedSportPark,
        this.props.match.field
      );
    }

    let timeWish = true;
    if (
      this.props.match &&
      this.props.match.field !== undefined &&
      this.props.match.field !== null &&
      this.props.matchStartTime &&
      this.props.matchEndTime
    ) {
      timeWish = checkRefereeWishDay(
        this.props.referee,
        this.props.selectedDay,
        this.props.matchStartTime,
        this.props.matchEndTime
      );
    }

    let style = {
      cursor:
        this.props.tournament.scheduleLocked || false ? "default" : "grab",
      margin: "0 1.5px",
      color:
        this.props.countRef1 > 1 ||
        this.props.countRef2 > 1 ||
        this.props.countRef3 > 1 ||
        this.props.countRef4 > 1 ||
        this.props.countRef5 > 1
          ? "#d50000"
          : "",
    };

    if (this.props.inSidebar) {
      style["color"] =
        !locationWish || !dayWish || !maxMatchesWish || !teamWish2
          ? "gray"
          : "";
      style["backgroundColor"] =
        !locationWish || !dayWish || !maxMatchesWish || !teamWish2
          ? "#f2f2f2"
          : "";
    }

    if (this.props.match && this.props.match.field !== null) {
      if (!locationWish) {
        wish = false;
        wishTitles.push(languages.referees.notAvailableAtLocation);
      } else if (!fieldWish) {
        wish = false;
        wishTitles.push(languages.referees.notAvailableAtField);
      }

      if (!dayWish) {
        wish = false;
        wishTitles.push(languages.referees.notAvailableOnDay);
      } else if (!timeWish) {
        wish = false;
        let value = (this.props.referee["availability"] || {})[
          this.props.selectedDay
        ];
        let valueString = "";
        if (value === undefined) {
          value = "all";
        }
        if (value !== "all" && value !== "none") {
          valueString =
            (value.start ? languages.referees.from + " " : "") +
            (value.start || "") +
            " " +
            (value.end ? languages.referees.until + " " : "") +
            " " +
            (value.end || "");
        }
        wishTitles.push(
          languages.referees.notAvailableOnTime +
            (valueString ? " (" + valueString + ")" : "")
        );
      }

      if (!maxMatchesWish) {
        wish = false;
        wishTitles.push(
          languages.formatString(
            languages.referees.maxMatchesReached,
            this.props.referee.maxMatches
          )
        );
      }
      if (!roleWish) {
        wish = false;
        let roleString = roles.map((r) => languages.structure.ranks[r]);
        wishTitles.push(
          languages.formatString(
            languages.referees.notAvailableForRole,
            languages.structure.ranks[this.props.refereeRole]
          ) + (roleString.length > 0 ? " (" + roleString.join(", ") + ")" : "")
        );
      }
      if (!teamWish) {
        wish = false;
        wishTitles.push(
          languages.formatString(
            languages.referees.notRefForTeam,
            (this.props.referee.excludeTeams || []).indexOf(team1.id) !== -1
              ? team1.name || ""
              : team2.name || ""
          )
        );
      }
      if (!divisionWish) {
        wish = false;
        wishTitles.push(languages.referees.notAvailableForDivision);
      }
    }
    return (
      <Chip
        avatar={
          this.props.inSidebar ? (
            <Avatar
              style={{
                color: !maxMatchesWish ? "rgb(186, 0, 13)" : "rgb(90, 146, 22)",
                backgroundColor: !maxMatchesWish
                  ? "rgb(255, 235, 238)"
                  : "rgb(241, 248, 233)",
              }}
            >
              {numMatches}
            </Avatar>
          ) : !wish ? (
            <Avatar>
              <Tooltip
                title={
                  <div>
                    {wishTitles.map((t, i) => (
                      <div key={i}>{t}</div>
                    ))}
                  </div>
                }
                placement="top"
                arrow
              >
                <ErrorIcon
                  style={{ color: "#FF8C00", backgroundColor: "white" }}
                />
              </Tooltip>
            </Avatar>
          ) : (
            <Avatar>
              <Icon path={mdiWhistle} size={0.5} />
            </Avatar>
          )
        }
        className={
          "hoverItemReferee refereeElement teamElementId" + this.props.refereeId
        }
        size="small"
        label={this.props.referee.name || ""}
        style={style}
        onMouseOver={() => {
          this.highlightReferee(this.props.refereeId);
        }}
        onMouseLeave={() => {
          this.unHighlightReferee(this.props.refereeId);
        }}
      />
    );
  }
}

export default RefereeChip;
